import SnapActor from './SnapActor';
import getSymbol from '../style';

/**
 * 捕捉最近形状点行为类，在鼠标移动的过程中捕捉最近形状点.
 */
export default class NearestVertexSnapActor extends SnapActor {
    constructor(options) {
        super({
            filter: null, // 过滤函数
            snapStart: true,
            snapEnd: true,
            range: 0, // 最大捕捉范围，0：不限制；单位为像素
            ...options
        });

        /**
         * 捕捉到的要素对象
         * @type {object}
         */
        this.geometry = options.geometry;
    }

    /**
     * 捕捉方法
     * @param {object<geojson>} point 点经纬度几何，一般是鼠标的位置
     * @returns {object} snapResult - 捕捉结果
     */
    snap(point) {
        super.snap(point);

        const box = this.getBox(point);

        if (!this.geometry) {
            return null;
        }

        let minDis = this.options.range || Number.MAX_VALUE;
        const pointPixel = this._geojsonConverter.toPoint(point);
        const vertexes = this._getVertexes(this.geometry);

        for (let j = 0; j < vertexes.length; j++) {
            if (!this.options.snapStart && j === 0) {
                continue;
            }
            if (!this.options.snapEnd && j === vertexes.length - 1) {
                continue;
            }

            const dis = pointPixel.distanceTo(vertexes[j]);
            if (dis < minDis) {
                minDis = dis;
                this.snapPoint = vertexes[j];
                this.vertexIndex = j;
            }
        }
        
        if (this.snapPoint) {
            this.snapPoint = this._geojsonConverter.fromPoint(this.snapPoint);
        }

        return this.getSnapResult();
    }

    /**
     * 获取捕捉时的要绘制的图标信息
     * @return {array}
     */
    getDrawItems() {
        if (this.snapPoint) {
            return [
                {
                    geometry: this.snapPoint, // geojson
                    symbol: getSymbol('snap_pt_vector') // symbol json
                }
            ];
        }
        return [];
    }

    getSnapResult() {
        const result = super.getSnapResult();
        if (result) {
            result.vertexIndex = this.vertexIndex;
            
            return result;
        }

        return null;
    }

    /**
     * 获取几何的形状点列表
     * @param {object}  geometry - 几何对象
     * @returns {array} 形状点几何对象列表
     */
    _getVertexes(geometry) {
        const vertexes = [];
        const pixelGeo = this._geojsonConverter.lngLatToPixel(geometry);
        if (pixelGeo.type === 'Point') {
            vertexes.push(L.point(pixelGeo.coordinates));
        } else if (pixelGeo.type === 'LineString') {
            for (const coord of pixelGeo.coordinates) {
                vertexes.push(L.point(coord));
            }
        } else if (pixelGeo.type === 'Polygon') {
            for (const coord of pixelGeo.coordinates[0]) {
                vertexes.push(L.point(coord));
            }
        }

        return vertexes;
    }
}
